import React from "react";
import { Helmet } from "react-helmet";
import "../css/privacy-policy.css";

const PrivacyPolicy = () => {
  return (
    <div>
      <Helmet>
        <title>Privacy Policy | Aaradhya Travels</title>

        <meta
          name="description"
          content="Privacy Policy for Aaradhya Travels. Learn how we collect, use, and protect your personal information for cab booking and travel services."
        />

        <meta
          name="keywords"
          content="Aaradhya Travels, Cab Service, Taxi Booking, Outstation Travel, Privacy Policy"
        />
      </Helmet>

      {/* Breadcrumb */}


             <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  Privacy Policy
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <section className="privacy-policy">
        <div className="container px-0">

           


          <div className="row g-0">
             <img className="img-fluid" src="/images/privacy.png" />
            <div className="col-12 col-md-12">

              <h3 className="title">
                Privacy Policy – Aaradhya Travels
              </h3>

              <p>
                At <b>Aaradhya Travels</b>, we value your privacy and are
                committed to protecting your personal information.
                This Privacy Policy explains how we collect, use,
                store, and safeguard your data when you use our
                cab booking and travel services.
              </p>

              {/* Information We Collect */}
              <div className="section">

                <p className="highlight darkcolor">
                  Information We Collect:
                </p>

                <p className="highlight darkcolor">
                  1. Personal Information:
                </p>

                <p>
                  When you contact or book a service with Aaradhya Travels,
                  we may collect your name, mobile number, email address,
                  pickup and drop locations, travel dates, and payment details.
                </p>

                <p className="highlight darkcolor">
                  2. Booking Details:
                </p>

                <p>
                  We collect travel-related information including vehicle
                  preferences, number of passengers, destination details,
                  and itinerary information for better service management.
                </p>

                <p className="highlight darkcolor">
                  3. Website Usage Information:
                </p>

                <p>
                  We may collect technical data such as IP address,
                  browser type, device information, and pages visited
                  to improve website performance and user experience.
                </p>

              </div>

              {/* How We Use */}
              <div className="section">

                <p className="highlight darkcolor">
                  How We Use Your Information:
                </p>

                <p className="highlight darkcolor">
                  1. Booking & Service Management:
                </p>

                <p>
                  Your information helps us confirm bookings,
                  assign drivers, manage schedules, and provide
                  smooth travel services.
                </p>

                <p className="highlight darkcolor">
                  2. Customer Support:
                </p>

                <p>
                  We use your contact details to share booking updates,
                  driver information, travel notifications,
                  and support assistance.
                </p>

                <p className="highlight darkcolor">
                  3. Service Improvement:
                </p>

                <p>
                  We analyze customer feedback and usage data to
                  improve our services and customer experience.
                </p>

                <p className="highlight darkcolor">
                  4. Promotional Communication:
                </p>

                <p>
                  With your permission, we may send offers,
                  discounts, and updates related to Aaradhya Travels services.
                </p>

              </div>

              {/* Sharing Information */}
              <div className="section">

                <p className="highlight darkcolor">
                  Information Sharing:
                </p>

                <p className="highlight darkcolor">
                  1. Drivers & Staff:
                </p>

                <p>
                  Necessary booking information may be shared
                  with drivers and our operations team
                  to provide transportation services.
                </p>

                <p className="highlight darkcolor">
                  2. Legal Requirements:
                </p>

                <p>
                  We may disclose information if required by law,
                  government authorities, or to ensure customer safety.
                </p>

              </div>

              {/* Security */}
              <div className="section">

                <p className="highlight darkcolor">
                  Data Security:
                </p>

                <p>
                  Aaradhya Travels follows reasonable security practices
                  to protect your personal information from unauthorized access,
                  misuse, or disclosure.
                </p>

                <p className="highlight darkcolor">
                  Your Rights:
                </p>

                <p>
                  You may request access, correction, or deletion
                  of your personal data and opt out of marketing communication
                  at any time.
                </p>

                <p className="highlight darkcolor">
                  Policy Updates:
                </p>

                <p>
                  This Privacy Policy may be updated periodically.
                  Updated policies will be posted on this page.
                </p>

              </div>

            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">

            <h2>Contact Us</h2>

            <p>
              If you have any questions regarding this Privacy Policy,
              please contact Aaradhya Travels:
            </p>

            <ul>

              <li>
                <b>Phone:</b>{" "}
                <a href="tel:+919529697070">
                  +91 9529697070
                </a>
              </li>

              <li>
                <b>Email:</b>{" "}
                <a href="mailto:booking@aaradhyatravels99.com">
                  booking@aaradhyatravels99.com
                </a>
              </li>

              <li>
                <b className="darkcolorrr">Address:</b>

                <br />

                <h6>Aaradhya Travels</h6>

                Near RMD College, Opp. Chaudhary Parking, <br/>Warje, Pune - 411058


              </li>

            </ul>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;